
(function() {
  function getCookie(name) {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }

    return '';
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    document.cookie =
      name + '=' + value +
      ';expires=' + date.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  function activatePopup(popup) {
    if (!popup) return;

    popup.classList.add('active');
    document.body.classList.add('overflow-hidden');

    const overlay = document.querySelector('.theme-modal-popup__overlay');

    if (overlay) {
      overlay.classList.add('active');
    }

    setTimeout(function() {
      if (typeof trapFocus === 'function') {
        trapFocus(popup);
      }
    }, 100);
  }

  function deactivatePopup(popup) {
    if (!popup) return;

    popup.classList.remove('active');

    const anotherActivePopup = document.querySelector(
      '.theme-modal-popup.active'
    );

    if (!anotherActivePopup) {
      document.body.classList.remove('overflow-hidden');

      const overlay = document.querySelector(
        '.theme-modal-popup__overlay'
      );

      if (overlay) {
        overlay.classList.remove('active');
      }
    }
  }

  // AGE VERIFICATION
  let checkAgeVerified = true;

  const agePopup = document.querySelector(
    '[data-popup-type="age-verification"]'
  );

  const ageCookie = getCookie('age-verification');

  if (
    agePopup &&
    ageCookie === '' &&
    document.querySelectorAll('.theme-modal-popup.design__mode').length === 0
  ) {
    checkAgeVerified = false;
    activatePopup(agePopup);
  }

  // NEWSLETTER POPUP
  const newsletterPopup = document.querySelector(
    '[data-popup-type="newsletter"]'
  );

  let newsletterCloseTimer = null;

  if (
    checkAgeVerified &&
    newsletterPopup &&
    document.querySelectorAll('.theme-modal-popup.design__mode').length === 0
  ) {
    const successMessage = newsletterPopup.querySelector(
      '.op-success-message'
    );

    const newsletterFields = newsletterPopup.querySelector(
      '.newsletter-form__field-wrapper'
    );

    const currentUrl = new URL(window.location.href);

    const customerPosted =
      currentUrl.searchParams.get('customer_posted') === 'true';

    const newsletterAnchor = [
      '#newsletter-popup',
      '#newsletter-popup-form'
    ].includes(currentUrl.hash);

    const successfulReturn = customerPosted || newsletterAnchor;

    // SUCCESSFUL SUBSCRIPTION
    if (successfulReturn) {
      setCookie('newsletter-subscribed', 'true', 3650);
      setCookie('newsletter-popup', 'true', 3650);

      currentUrl.searchParams.delete('customer_posted');
      currentUrl.hash = '';

      window.history.replaceState(
        {},
        document.title,
        currentUrl.pathname + currentUrl.search
      );
    }

    if (successfulReturn || successMessage) {

      // Hide subscription form
      if (newsletterFields) {
        newsletterFields.style.display = 'none';
      }

      let thankYouMessage = successMessage;

      // Create confirmation if Shopify doesn't render one
      if (!thankYouMessage) {
        thankYouMessage = document.createElement('div');
        thankYouMessage.className = 'op-success-message';

        thankYouMessage.setAttribute('role', 'status');
        thankYouMessage.setAttribute('aria-live', 'polite');

        thankYouMessage.innerHTML =
          '<strong>Danke für deine Anmeldung!</strong>' +
          '<p>Dein persönlicher 10 %-Rabattcode ist unterwegs an deine E-Mail-Adresse.</p>';

        newsletterPopup
          .querySelector('.newsletter-email-form')
          .appendChild(thankYouMessage);
      }

      thankYouMessage.style.display = 'block';

      // Mark popup as successful
      newsletterPopup.classList.add('newsletter-popup-success');

      // Show confirmation immediately
      activatePopup(newsletterPopup);

      // Automatically close after 2 seconds
      newsletterCloseTimer = setTimeout(function() {
        deactivatePopup(newsletterPopup);
      }, 2000);

    } else if (
      getCookie('newsletter-subscribed') !== 'true' &&
      getCookie('newsletter-popup') === ''
    ) {

      // NORMAL NEWSLETTER POPUP
      const popupDelayTime = parseInt(
        newsletterPopup.dataset.popupDelaySeconds,
        10
      ) || 4000;

      setTimeout(function() {
        if (
          getCookie('newsletter-subscribed') !== 'true' &&
          getCookie('newsletter-popup') === ''
        ) {
          activatePopup(newsletterPopup);
        }
      }, popupDelayTime);
    }
  }

  // AGE VERIFICATION BUTTON
  const ageVerifiedButton = document.querySelector(
    '.age-varified__button'
  );

  if (ageVerifiedButton) {
    ageVerifiedButton.addEventListener('click', function(event) {
      event.preventDefault();

      const popup = document.querySelector(
        '[data-popup-type="age-verification"]'
      );

      if (popup) {
        setCookie(
          'age-verification',
          'true',
          parseInt(popup.dataset.popupDelayDays, 10) || 30
        );

        deactivatePopup(popup);
      }
    });
  }

  // CLOSE BUTTONS
  const popupCloseButtons = document.querySelectorAll(
    '.btn-modal-popup__trigger'
  );

  popupCloseButtons.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modalId = this.getAttribute('data-modal-id');

      const popup = document.querySelector(
        '.theme-modal-popup[data-popup-type="' + modalId + '"]'
      );

      if (!popup) return;

      if (modalId === 'newsletter') {
        if (newsletterCloseTimer) {
          clearTimeout(newsletterCloseTimer);
        }

        const showAgainDays =
          parseInt(popup.dataset.popupDelayDays, 10) || 7;

        setCookie('newsletter-popup', 'true', showAgainDays);
      }

      deactivatePopup(popup);
    });
  });

})();
